import {
    AccessorsMutatorsDecorator
} from "../../helpers";
import {
    TranslatableModel
} from "./translatable-model";

export class EmailTemplate extends TranslatableModel {

    static get translatableAttributes() {
        
        return [ 'name', 'subject', 'message'];
    }

    static get validationModel(){

        return {};
    }

    static get getStandartsList(){

        return [
            'pending_confirmation',
            'reservation_confirmed',
            'reservation_cancelled',
            'reservation_invoice',
            'reservation_folio'
        ];
    }

}

AccessorsMutatorsDecorator('id', ...EmailTemplate.translatableAttributesWithLanguageAliases, 'property','property_id','send_from', 'reply_to',
    'status', 'language', 'cc_list', 'bcc_list', 'created_at', 'updated_at', 'standart', 'schedule', 'reset_default')(EmailTemplate);


// WEBPACK FOOTER //
// ./src/pms-api/models/email-template.model.js